module.exports = __webpack_public_path__ + "ab713b73d77bade5d11bf85f910b297c.svg";